"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useClickOutside;

var _react = require("react");

// eslint-disable-next-line max-len
// Inspired from https://github.com/mantinedev/mantine/blob/master/src/mantine-hooks/src/use-click-outside/use-click-outside.ts
function useClickOutside(callback) {
  var eventTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['mousedown', 'touchstart'];
  var targetRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var listener = function listener(event) {
      if (targetRef.current && !targetRef.current.contains(event.target)) {
        callback();
      }
    };

    eventTypes.forEach(function (eventType) {
      return document.addEventListener(eventType, listener);
    });
    return function () {
      eventTypes.forEach(function (eventType) {
        return document.removeEventListener(eventType, listener);
      });
    };
  }, [targetRef, callback]);
  return targetRef;
}